import { render, staticRenderFns } from "./ProformaTabs.vue?vue&type=template&id=84fdd910&scoped=true"
import script from "./ProformaTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProformaTabs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fdd910",
  null
  
)

export default component.exports